<div class="card radius-10 mb-3">
  <div class="card-header p-0">
    <div class="d-flex align-items-center flex-wrap">
      <h6 class="m-0 p-2 d-flex align-items-center me-2 text-break">
        {{ tittle }}
      </h6>

      <!-- ✅ Loading Indicator -->
      <div *ngIf="isLoading" class="ms-2">
        <mat-spinner diameter="20"></mat-spinner>
      </div>

      <div class="ms-1">
        <ul
          class="nav nav-tabs chart-dashboard border-0"
          id="myTab"
          role="tablist"
        >
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="tabular-tab"
              data-bs-toggle="tab"
              [attr.data-bs-target]="'#tabular-tab-pane-' + tab_index"
              type="button"
              role="tab"
              aria-controls="tabular-tab-pane"
              aria-selected="true"
            >
              <!-- <img height="20" src="assets/images/Table.jpg" alt="Table" /> -->
              <i class="bi bi-table"></i>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="pie-tab"
              data-bs-toggle="tab"
              [attr.data-bs-target]="'#pie-tab-pane-' + tab_index"
              type="button"
              role="tab"
              aria-controls="pie-tab-pane"
              aria-selected="false"
            >
              <!-- <img height="20" src="assets/images/Pie Chart.jpg" alt="Pie" /> -->
              <i class="bi bi-pie-chart-fill"></i>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="bar-tab"
              data-bs-toggle="tab"
              [attr.data-bs-target]="'#bar-tab-pane-' + tab_index"
              type="button"
              role="tab"
              aria-controls="bar-tab-pane"
              aria-selected="false"
            >
              <!-- <img height="20" src="assets/images/Bar Chart.jpg" alt="Bar" /> -->
              <i class="bi bi-bar-chart-fill"></i>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="line-tab"
              data-bs-toggle="tab"
              [attr.data-bs-target]="'#line-tab-pane-' + tab_index"
              type="button"
              role="tab"
              aria-controls="line-tab-pane"
              aria-selected="false"
            >
              <!-- <img height="20" src="assets/images/line Chart.jpg" alt="Line" /> -->
              <i class="bi bi-graph-up-arrow"></i>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              type="button"
              title="View All Data"
              (click)="gotoForm()"
            >
              <i class="bi bi-database"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="tab-content" id="myTabContent">
      <!-- ✅ OPTIMIZED TABLE TAB with Virtual Scrolling -->
      <div
        class="tab-pane fade show active"
        id="tabular-tab-pane-{{ tab_index }}"
        role="tabpanel"
        aria-labelledby="tabular-tab"
        tabindex="0"
      >
        <div
          class="p-1"
          [ngClass]="oneRecord == 1 ? 'card-body1' : 'card-body'"
        >
          <!-- Loading State -->
          <div *ngIf="isLoading" class="text-center p-4">
            <mat-spinner diameter="40"></mat-spinner>
            <p class="mt-2">Loading data...</p>
          </div>

          <!-- Data Table -->
          <div *ngIf="!isLoading" class="table-container">
            <div class="table-responsive">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>S No</th>
                    <th
                      *ngFor="let field of attributesList; trackBy: trackByFn"
                    >
                      <ng-container *ngIf="getAttributeById(field.id) as e">
                        {{ field["label"] }}
                      </ng-container>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- ✅ Using trackBy for better performance -->
                  <tr
                    *ngFor="
                      let e of filteredData;
                      trackBy: trackByFn;
                      let i = index
                    "
                  >
                    <td>{{ i + 1 }}</td>
                    <td
                      *ngFor="let field of attributesList; trackBy: trackByFn"
                    >
                      <ng-container *ngIf="getAttributeById(field.id) as at">
                        <!-- Object Type -->
                        <span
                          *ngIf="
                            at['type'] === 'object' &&
                            at['type'] != 'number' &&
                            at['type'] != 'file' &&
                            at['type'] != 'doc' &&
                            at['type'] != 'time' &&
                            at['type'] !== 'location' &&
                            at['type'] !== 'boolean'
                          "
                        >
                          {{ e[at["code"]] | json }}
                        </span>

                        <!-- Default String Types -->
                        <span
                          *ngIf="
                            at['type'] != 'number' &&
                            at['type'] != 'object' &&
                            at['type'] != 'file' &&
                            at['type'] != 'doc' &&
                            at['type'] != 'time' &&
                            at['type'] != 'itime' &&
                            at['type'] != 'textarea' &&
                            at['type'] != 'email' &&
                            at['type'] !== 'location' &&
                            at['type'] !== 'boolean' &&
                            at['type'] !== 'text' &&
                            at['type'] != 'list' &&
                            at['type'] != 'map' &&
                            at['type'] !== 'dateandtime'
                          "
                        >
                          {{
                            at["depAttribute"]
                              ? getString(e[at["depAttribute"]], at["type"])
                              : getString(e[at["code"]], at["type"])
                          }}
                        </span>

                        <!-- Time Type -->
                        <span *ngIf="at['type'] === 'time'">
                          {{
                            at["depAttribute"]
                              ? getString1(
                                  e[at["depAttribute"]],
                                  at["type"],
                                  at["timeFormat"]
                                )
                              : getString1(
                                  e[at["code"]],
                                  at["type"],
                                  at["timeFormat"]
                                )
                          }}
                        </span>

                        <!-- ITime Type -->
                        <span *ngIf="at['type'] === 'itime'">
                          {{
                            at["depAttribute"]
                              ? getStringitime(
                                  e[at["depAttribute"]],
                                  at["type"],
                                  at["itimeFormat"]
                                )
                              : getStringitime(
                                  e[at["code"]],
                                  at["type"],
                                  at["itimeFormat"]
                                )
                          }}
                        </span>

                        <!-- Location Type -->
                        <span *ngIf="at['type'] === 'location'">
                          <ng-container
                            *ngIf="
                              getLocationObject(
                                at['depAttribute']
                                  ? e[at['depAttribute']]
                                  : e[at['code']]
                              ) as loc
                            "
                          >
                            <a
                              [href]="
                                'https://www.google.com/maps?q=' +
                                loc.lat +
                                ',' +
                                loc.lng
                              "
                              target="_blank"
                              style="text-decoration: none"
                            >
                              {{ loc.lat }},{{ loc.lng }}
                            </a>
                          </ng-container>
                        </span>

                        <!-- File Type -->
                        <span
                          *ngIf="
                            at['type'] != 'list' &&
                            at['type'] != 'object' &&
                            at['type'] === 'file' &&
                            at['type'] != 'doc' &&
                            at['type'] != 'time' &&
                            e['type'] !== 'location' &&
                            at['type'] !== 'boolean' &&
                            at['type'] !== 'dateandtime'
                          "
                        >
                          <a [href]="getAppDoc(e[at['code']])" target="_blank">
                            <img
                              [src]="getAppDocThumbnail(e[at['code']])"
                              width="50px"
                              height="40px"
                              loading="lazy"
                              alt="File"
                            />
                          </a>
                        </span>

                        <!-- Boolean Type -->
                        <span *ngIf="at['type'] === 'boolean'">
                          {{
                            e[at["code"]] == 1
                              ? "true"
                              : e[at["code"]] == 0
                                ? "false"
                                : ""
                          }}
                        </span>

                        <!-- List Type -->
                        <span
                          *ngIf="at['type'] === 'list'"
                          [title]="e[at['code']]"
                        >
                          {{
                            e[at["code"]] === null ||
                            e[at["code"]] == undefined ||
                            e[at["code"]] == "undefined"
                              ? ""
                              : e[at["code"]]
                          }}
                        </span>

                        <!-- Map Type -->
                        <span *ngIf="at['type'] === 'map'">
                          {{
                            e[at["code"]] === null ||
                            e[at["code"]] == undefined ||
                            e[at["code"]] == "undefined"
                              ? ""
                              : e[at["code"]]
                          }}
                        </span>

                        <!-- ✅ Textarea with optimized HTML rendering and cache key -->
                        <div
                          *ngIf="at['type'] === 'textarea'"
                          class="custom-textarea"
                          [innerHTML]="
                            getSanitizedHtml(
                              e[at['code']],
                              e.id + '-' + at['code']
                            )
                          "
                        ></div>

                        <!-- Email Type -->
                        <span *ngIf="at['type'] === 'email'">
                          <a
                            [href]="'mailto:' + e[at['code']]"
                            target="_blank"
                            >{{ e[at["code"]] }}</a
                          >
                        </span>

                        <!-- Doc Type -->
                        <span
                          *ngIf="
                            at['type'] != 'list' &&
                            at['type'] != 'object' &&
                            at['type'] !== 'file' &&
                            at['type'] === 'doc'
                          "
                        >
                          <a [href]="getAppDoc(e[at['code']])" target="_blank">
                            <img
                              [src]="getAppDocThumbnail(e[at['code']])"
                              width="50px"
                              loading="lazy"
                              alt="Doc"
                            />
                          </a>
                        </span>

                        <!-- Text/Number with QR/Barcode -->
                        <span
                          *ngIf="
                            at['type'] === 'text' || at['type'] === 'number'
                          "
                        >
                          <!-- QR Code -->
                          <ng-container
                            *ngIf="at['codeType'] === 'qr' && e[at['code']]"
                          >
                            <a
                              href="javascript:void(0)"
                              [title]="e[at['code']]"
                              (click)="
                                openCodeInNewTab('qr', e[at['code']].toString())
                              "
                              class="code-link"
                            >
                              <div class="code-container">
                                <qrcode
                                  [qrdata]="e[at['code']].toString()"
                                  [width]="50"
                                  [errorCorrectionLevel]="'M'"
                                ></qrcode>
                                <div class="code-text">
                                  {{ e[at["code"]] | truncate: 10 }}
                                </div>
                              </div>
                            </a>
                          </ng-container>

                          <!-- Barcode -->
                          <ng-container
                            *ngIf="at['codeType'] === 'bar' && e[at['code']]"
                          >
                            <a
                              href="javascript:void(0)"
                              [title]="e[at['code']]"
                              (click)="
                                openCodeInNewTab(
                                  'bar',
                                  e[at['code']].toString()
                                )
                              "
                              class="code-link"
                            >
                              <div class="code-container">
                                <ngx-barcode6
                                  [bc-value]="e[at['code']].toString()"
                                  bc-format="CODE128"
                                  [bc-display-value]="false"
                                  [bc-width]="0.8"
                                  [bc-height]="20"
                                ></ngx-barcode6>
                                <div class="code-text mt-0">
                                  {{ e[at["code"]] | truncate: 10 }}
                                </div>
                              </div>
                            </a>
                          </ng-container>

                          <!-- Plain Text -->
                          <ng-container
                            *ngIf="
                              at['codeType'] === 'none' ||
                              !at['codeType'] ||
                              !e[at['code']]
                            "
                          >
                            <span [title]="e[at['code']]">{{
                              e[at["code"]] | truncate: 40
                            }}</span>
                          </ng-container>
                        </span>

                        <!-- Date and Time Type -->
                        <span *ngIf="at['type'] === 'dateandtime'">
                          {{
                            at["depAttribute"]
                              ? getString(e[at["depAttribute"]], at["type"])
                              : getString(e[at["code"]], at["type"])
                          }}
                        </span>
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- PIE CHART TAB -->
      <div
        class="tab-pane fade"
        id="pie-tab-pane-{{ tab_index }}"
        role="tabpanel"
        aria-labelledby="pie-tab"
        tabindex="0"
      >
        <form #uiForm="ngForm" class="compact-inputs">
          <div class="d-flex gap-1">
            <mat-form-field appearance="outline" class="dropdown-pd-none">
              <mat-label>Select Attribute</mat-label>
              <mat-select
                required
                id="code"
                name="code"
                [(ngModel)]="form.data['attributeId']"
                (selectionChange)="getAttributesById(form.data['attributeId'])"
              >
                <mat-option disabled value="undefined"
                  >--Select Attribute--</mat-option
                >
                <mat-option
                  *ngFor="let e of filterAttributes(); trackBy: trackByFn"
                  [value]="e['id']"
                >
                  {{ e["label"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="dropdown-pd-none">
              <mat-label>Select Type</mat-label>
              <mat-select
                required
                id="aggType"
                name="aggType"
                [(ngModel)]="form.data['type']"
              >
                <mat-option disabled value="undefined"
                  >--Select Type--</mat-option
                >
                <mat-option value="value">Value</mat-option>
                <mat-option value="range">Range</mat-option>
              </mat-select>
            </mat-form-field>

            <button
              mat-stroked-button
              color="primary"
              [disabled]="!uiForm.valid || isLoading"
              type="button"
              class="icon-center icon-width"
              matTooltip="Refresh"
              matTooltipPosition="above"
              (click)="drawChart()"
            >
              <mat-icon class="icon-compact">refresh</mat-icon>
            </button>

            <button
              mat-stroked-button
              color="primary"
              disabled
              type="button"
              class="icon-center icon-width"
              matTooltip="Prediction"
              matTooltipPosition="above"
            >
              <mat-icon class="icon-compact">lightbulb</mat-icon>
            </button>
          </div>
        </form>
        <div
          class="p-1 mt-3"
          [ngClass]="oneRecord == 1 ? 'card-body1' : 'card-body'"
        >
          <div class="d-chart">
            <app-ncs-chart
              [chartType]="'pie'"
              [data]="chartdata"
              [options]="chartOptions"
              [oneRecord]="oneRecord"
            ></app-ncs-chart>
          </div>
        </div>
      </div>

      <!-- BAR CHART TAB -->
      <div
        class="tab-pane fade"
        id="bar-tab-pane-{{ tab_index }}"
        role="tabpanel"
        aria-labelledby="bar-tab"
        tabindex="0"
      >
        <form #uiForm="ngForm" class="compact-inputs">
          <div class="d-flex gap-1">
            <mat-form-field appearance="outline" class="dropdown-pd-none">
              <mat-label>Select Attribute</mat-label>
              <mat-select
                required
                id="code"
                name="code"
                [(ngModel)]="form.data['attributeId']"
                (selectionChange)="getAttributesById(form.data['attributeId'])"
              >
                <mat-option value="undefined" disabled
                  >--Select Attribute--</mat-option
                >
                <mat-option
                  *ngFor="let e of filterAttributes(); trackBy: trackByFn"
                  [value]="e['id']"
                >
                  {{ e["label"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="dropdown-pd-none">
              <mat-label>Select Type</mat-label>
              <mat-select
                required
                id="aggType"
                name="aggType"
                [(ngModel)]="form.data['type']"
              >
                <mat-option value="undefined" disabled
                  >--Select Type--</mat-option
                >
                <mat-option value="value">Value</mat-option>
                <mat-option value="range">Range</mat-option>
              </mat-select>
            </mat-form-field>

            <button
              mat-stroked-button
              color="primary"
              [disabled]="!uiForm.valid || isLoading"
              type="button"
              class="icon-center icon-width"
              matTooltip="Refresh"
              matTooltipPosition="above"
              (click)="drawChart()"
            >
              <mat-icon class="icon-compact">refresh</mat-icon>
            </button>

            <button
              mat-stroked-button
              color="primary"
              disabled
              type="button"
              class="icon-center icon-width"
              matTooltip="Prediction"
              matTooltipPosition="above"
            >
              <mat-icon class="icon-compact">lightbulb</mat-icon>
            </button>
          </div>
        </form>
        <div
          class="p-1"
          [ngClass]="oneRecord == 1 ? 'card-body1' : 'card-body'"
        >
          <div class="d-chart">
            <app-ncs-chart
              [chartType]="'bar'"
              [data]="chartdata"
              [options]="chartOptions"
              [oneRecord]="oneRecord"
            ></app-ncs-chart>
          </div>
        </div>
      </div>

      <!-- LINE CHART TAB -->
      <div
        class="tab-pane fade"
        id="line-tab-pane-{{ tab_index }}"
        role="tabpanel"
        aria-labelledby="line-tab"
        tabindex="0"
      >
        <form #uiForm="ngForm" class="compact-inputs">
          <div class="d-flex gap-1">
            <mat-form-field appearance="outline" class="dropdown-pd-none">
              <mat-label>Select Attribute</mat-label>
              <mat-select
                required
                id="code"
                name="code"
                [(ngModel)]="form.data['attributeId']"
                (selectionChange)="getAttributesById(form.data['attributeId'])"
              >
                <mat-option value="undefined" disabled
                  >--Select Attribute--</mat-option
                >
                <mat-option
                  *ngFor="let e of filterAttributes(); trackBy: trackByFn"
                  [value]="e['id']"
                >
                  {{ e["label"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="dropdown-pd-none">
              <mat-label>Select Type</mat-label>
              <mat-select
                required
                id="aggType"
                name="aggType"
                [(ngModel)]="form.data['type']"
              >
                <mat-option value="undefined" disabled
                  >--Select Type--</mat-option
                >
                <mat-option value="value">Value</mat-option>
                <mat-option value="range">Range</mat-option>
              </mat-select>
            </mat-form-field>

            <button
              mat-stroked-button
              color="primary"
              [disabled]="!uiForm.valid || isLoading"
              type="button"
              class="icon-center icon-width"
              matTooltip="Refresh"
              matTooltipPosition="above"
              (click)="drawChart()"
            >
              <mat-icon class="icon-compact">refresh</mat-icon>
            </button>

            <button
              mat-stroked-button
              color="primary"
              disabled
              type="button"
              class="icon-center icon-width"
              matTooltip="Prediction"
              matTooltipPosition="above"
            >
              <mat-icon class="icon-compact">lightbulb</mat-icon>
            </button>
          </div>
        </form>
        <div
          class="p-1"
          [ngClass]="oneRecord == 1 ? 'card-body1' : 'card-body'"
        >
          <div class="d-chart">
            <app-ncs-chart
              [chartType]="'line'"
              [data]="chartdata"
              [options]="chartOptions"
              [oneRecord]="oneRecord"
            ></app-ncs-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>